// Topbar shared strings — EN + TR.
//
// Wave-1 Day 2 wiring. Topbar M0 simulation banner + role switcher prompt +
// "Acting as:" label. Role option labels stay role-name based ("Admin",
// "Seller", "Supply") — proper-noun persona names ("Volkan", "Sarah",
// "Mehmet") are not translated.

import type { LocalizedDict } from '../index'

type TopbarStrings = {
  actingAs: string
  selectRolePrompt: string
  searchComingSoon: string
  searchUnavailableLabel: string
  openNavigation: string
  switchRole: string
  roleLabels: {
    admin: string
    seller: string
    supply: string
  }
}

export const topbarI18n: LocalizedDict<TopbarStrings> = {
  en: {
    actingAs: 'Acting as:',
    selectRolePrompt: '— select role —',
    searchComingSoon: 'Search products, orders, stores — Coming soon',
    searchUnavailableLabel: 'Global search is coming soon',
    openNavigation: 'Open navigation menu',
    switchRole: 'Switch role',
    roleLabels: {
      admin: 'Admin',
      seller: 'Seller',
      supply: 'Supply',
    },
  },
  tr: {
    actingAs: 'Rolün:',
    selectRolePrompt: '— rol seç —',
    searchComingSoon: 'Ürün, sipariş ve mağaza ara — Yakında',
    searchUnavailableLabel: 'Global arama yakında kullanıma açılacak',
    openNavigation: 'Menüyü aç',
    switchRole: 'Rol değiştir',
    roleLabels: {
      admin: 'Admin',
      seller: 'Satıcı',
      supply: 'Üretim',
    },
  },
}
